export enum API_VERSION {
  V1 = '1',
  V2 = '2',
}

export const CURRENT_API_VERSION = API_VERSION.V1;
